/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantPosConfig } from '../../models/tenant-pos-config';

export interface DefaultConfigsConfigIdGet$Params {
  'Active-Tenant-Identifier': string;
  configId: string;
}

export function defaultConfigsConfigIdGet(http: HttpClient, rootUrl: string, params: DefaultConfigsConfigIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantPosConfig>> {
  const rb = new RequestBuilder(rootUrl, defaultConfigsConfigIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('configId', params.configId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantPosConfig>;
    })
  );
}

defaultConfigsConfigIdGet.PATH = '/default-configs/{configId}';
